/* Splits a description at the first ⚠️ marker into [before, warning]. */
export function splitWarning(description: string): [string, string | null] {
    const idx = description.indexOf('⚠️');
    if (idx === -1) return [description, null];
    return [description.slice(0, idx).trimEnd(), description.slice(idx)];
}
